import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
TextField,
Alert,
CircularProgress
} from "@mui/material";

import { Colors } from "../utils/colors";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "../constant/apiConstant";
import BackHeader from "../components/BackHeader";

export default function VerifyDeleteOTP(){

const navigate = useNavigate()
const location = useLocation()

const email = location.state?.email || ""

const [otp,setOtp] = useState("")
const [loading,setLoading] = useState(false)

const [alert,setAlert] = useState({
open:false,
message:"",
severity:"success"
})

const showAlert=(severity,message,time=6000)=>{

setAlert({
open:true,
severity,
message
})

setTimeout(()=>{
setAlert(prev=>({...prev,open:false}))
},time)

}




const verifyOTP = async () => {

setLoading(true)

try{

const res = await fetch(`${API.BASE_URL}/api/auth/verify-delete-account-otp`,{
method:"POST",
credentials:"include",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({
email,
otp
})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Invalid OTP")
setLoading(false)
return

}

showAlert("success",data.message || "Account deletion request submitted")

setTimeout(()=>{
navigate("/account/authmenu/account/profile-kyc/account-deletion-notice",{state:{email}})
},1500)

}catch(error){

console.log(error)

showAlert("error","Unable to verify OTP")

}

setLoading(false)

}




const resendOTP = async () => {

try{

const res = await fetch(`${API.BASE_URL}/api/auth/send-delete-account-otp`,{
method:"POST",
credentials:"include",
headers:{
"Content-Type":"application/json"
},
body:JSON.stringify({email})
})

const data = await res.json()

if(!data.status){

showAlert("error",data.message || "Failed to resend OTP")

}else{

showAlert("success","OTP resent successfully")

}

}catch(error){

showAlert("error","Unable to resend OTP")

}

}


return(

<Box
sx={{
minHeight:"100vh",
p:3,
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<Card sx={{p:4,borderRadius:1,width:"100%",maxWidth:500}}>

<BackHeader
title="Verify Deletion OTP"
fallbackRoute="/account/authmenu/account/profile-kyc"
titleSx={{color:Colors.accent,fontWeight:700}}
/>

<Typography
sx={{
color:Colors.muted,
fontSize:14
}}
>
Enter the OTP sent to your email to continue account deletion.
</Typography>


{alert.open && (
<Alert severity={alert.severity} sx={{mt:2}}>
{alert.message}
</Alert>
)}


<TextField
label="Email Address"
fullWidth
sx={inputStyle}
value={email}
disabled
/>

<TextField
label="Enter OTP"
fullWidth
sx={inputStyle}
value={otp}
onChange={(e)=>setOtp(e.target.value)}
/>


<Button
fullWidth
variant="contained"
sx={{
mt:3,
backgroundColor:"#d32f2f",
color:"#fff",
fontWeight:700,
"&:hover":{
backgroundColor:"#b71c1c"
}
}}
disabled={otp.length < 4 || loading}
onClick={verifyOTP}
>

{loading
? <CircularProgress size={24} sx={{color:"white"}}/>
: "Verify OTP"
}

</Button>


<Typography
sx={{
mt:2,
textAlign:"center",
color:Colors.muted,
fontSize:14
}}
>

Didn't receive OTP?{" "}
<span
style={{
color:Colors.accent,
cursor:"pointer",
textDecoration:"underline",
fontWeight:600
}}
onClick={resendOTP}
>
Resend OTP
</span>

</Typography>

</Card>

</Box>

)

}


const inputStyle={
mt:2,
"& .MuiOutlinedInput-root":{
"& fieldset":{borderColor:Colors.accent},
"&:hover fieldset":{borderColor:Colors.accent},
"&.Mui-focused fieldset":{borderColor:Colors.accent}
},
"& .MuiInputLabel-root":{
color:Colors.accent
},
"& .MuiInputLabel-root.Mui-focused":{
color:Colors.accent
},
input:{
color:"whitesmoke"
}
}
